/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { IIconNamePathPair } from '../core/models';
import { MapIconRegistryService } from '../core/services';

const icInfoBlue = 'assets/images/device-health-check/ic-info-blue.svg';
const icThumbsUp = 'assets/images/device-health-check/ic-thumbs-up.svg';
const icThumbsDown = 'assets/images/device-health-check/ic-thumbs-down.svg';
const icExclamation = 'assets/images/device-health-check/ic-exclamation.svg';

@NgModule()
export class DeviceHealthCheckIconModule {
  private readonly _icons: IIconNamePathPair[] = [
    { name: 'ic-info-blue', svg: icInfoBlue },
    { name: 'ic-thumbs-up', svg: icThumbsUp },
    { name: 'ic-thumbs-down', svg: icThumbsDown },
    { name: 'ic-exclamation', svg: icExclamation }
  ];

  constructor(private readonly _mapIconRegistryService: MapIconRegistryService) {
    this._registerIcons();
  }

  private _registerIcons() {
    this._icons.forEach(icon => this._mapIconRegistryService.addSvgIconByPath(icon));
  }
}
